import i18n from "i18next";
import Backend from "i18next-chained-backend";
import XHRBackend from "i18next-xhr-backend";
import LocalStorageBackend from "i18next-localstorage-backend";
import { initReactI18next } from 'react-i18next';
import { I18N_VERSION } from "../constants/i18nVersion";

function cacheEnabled() {
  return process.env.NODE_ENV === "production";
}

i18n
  // load translation using xhr -> see /public/locales
  // learn more: https://github.com/i18next/i18next-xhr-backend
  .use(Backend)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    backend: {
      backends: [
        LocalStorageBackend, // primary
        XHRBackend // fallback
      ],
      backendOptions: [
        {
          enabled: cacheEnabled(),
          expirationTime: 24 * 60 * 60 * 1000, // 24 hours
          prefix: "pc_i18next_res_",
          versions: {
            de: I18N_VERSION,
            enUk: I18N_VERSION,
            es: I18N_VERSION,
            fr: I18N_VERSION,
            it: I18N_VERSION,
            nl: I18N_VERSION,
            pl: I18N_VERSION
          }
        },
        {
          addPath: "/locales/{{lng}}/{{ns}}-missing.json",
          allowMultiLoading: false,
          crossDomain: true,
          loadPath: `${process.env.PUBLIC_URL}/locales/{{lng}}/{{ns}}.json`,
          queryStringParams: { v: I18N_VERSION }
        }
      ]
    },
    debug: false,
    fallbackLng: false,
    interpolation: {
      escapeValue: false, // not needed for react
      format: function(value, format, lng) {
        if (format === "uppercase") return value.toUpperCase();
        return value;
      },
      formatSeparator: ","
    },
    react: {
      wait: true
    },
    useCookie: false
  });

export default i18n;
